import update from '../../../helpers/update';
import {
  getListData,
  getMetadata,
  createRecord,
  updateRecord,
  getRecord,
  deleteRecord,
} from '../../../modules/bin/entityHandlers';
import { EVENT_ORGANIZER_API_PATH } from '../../../constants/eventOrganizer';
import {
  EVENT_ORGANIZERS_MESSAGE_CLEAR,
  EVENT_ORGANIZERS_METADATA_REQUESTED,
  EVENT_ORGANIZERS_METADATA_SUCCESS,
  EVENT_ORGANIZERS_METADATA_FAILURE,
  EVENT_ORGANIZERS_LIST_DATA_REQUESTED,
  EVENT_ORGANIZERS_LIST_DATA_SUCCESS,
  EVENT_ORGANIZERS_LIST_DATA_FAILURE,
  EVENT_ORGANIZERS_CREATE_REQUESTED,
  EVENT_ORGANIZERS_CREATE_SUCCESS,
  EVENT_ORGANIZERS_CREATE_FAILURE,
  EVENT_ORGANIZERS_UPDATE_REQUESTED,
  EVENT_ORGANIZERS_UPDATE_SUCCESS,
  EVENT_ORGANIZERS_UPDATE_FAILURE,
  EVENT_ORGANIZERS_GET_REQUESTED,
  EVENT_ORGANIZERS_GET_SUCCESS,
  EVENT_ORGANIZERS_GET_FAILURE,
  EVENT_ORGANIZERS_DELETE_REQUESTED,
  EVENT_ORGANIZERS_DELETE_SUCCESS,
  EVENT_ORGANIZERS_DELETE_FAILURE,
} from './eventOrganizerTypes';

export const clearEventOrganizerErrors = (record: any) => ({
  type: EVENT_ORGANIZERS_MESSAGE_CLEAR,
  payload: { key: record },
});

export const getEventOrganizerMetadata = (listKey: any) =>
  getMetadata(
    EVENT_ORGANIZER_API_PATH,
    listKey,
    EVENT_ORGANIZERS_METADATA_REQUESTED,
    EVENT_ORGANIZERS_METADATA_SUCCESS,
    EVENT_ORGANIZERS_METADATA_FAILURE
  );

export const getEventOrganizerListData = (
  listKey: any,
  id: any,
  request: any,
  invalidate = false,
  cachedData?: any
) =>
  getListData(
    EVENT_ORGANIZER_API_PATH,
    listKey,
    id,
    EVENT_ORGANIZERS_LIST_DATA_REQUESTED,
    EVENT_ORGANIZERS_LIST_DATA_SUCCESS,
    EVENT_ORGANIZERS_LIST_DATA_FAILURE,
    request,
    invalidate,
    cachedData
  );

export const getEventOrganizerListDataBySearchTerm = (
  listKey: any,
  id: any,
  request: any,
  searchTerm: string
) => {
  const newRequest = update(request, { text: { $set: searchTerm } });
  return getEventOrganizerListData(listKey, id, newRequest, true);
};

export const createEventOrganizer = (payload: any) =>
  createRecord(
    EVENT_ORGANIZER_API_PATH,
    EVENT_ORGANIZERS_CREATE_REQUESTED,
    EVENT_ORGANIZERS_CREATE_SUCCESS,
    EVENT_ORGANIZERS_CREATE_FAILURE,
    payload,
    null,
    'recordCreate'
  );

export const updateEventOrganizer = (id: number, payload: any) =>
  updateRecord(
    EVENT_ORGANIZER_API_PATH,
    EVENT_ORGANIZERS_UPDATE_REQUESTED,
    EVENT_ORGANIZERS_UPDATE_SUCCESS,
    EVENT_ORGANIZERS_UPDATE_FAILURE,
    id,
    payload,
    null,
    'recordEdit'
  );

export const getEventOrganizer = (id: number) =>
  getRecord(
    EVENT_ORGANIZER_API_PATH,
    EVENT_ORGANIZERS_GET_REQUESTED,
    EVENT_ORGANIZERS_GET_SUCCESS,
    EVENT_ORGANIZERS_GET_FAILURE,
    id,
    'recordEdit'
  );

export const deleteEventOrganizer = (id: number) =>
  deleteRecord(
    EVENT_ORGANIZER_API_PATH,
    EVENT_ORGANIZERS_DELETE_REQUESTED,
    EVENT_ORGANIZERS_DELETE_SUCCESS,
    EVENT_ORGANIZERS_DELETE_FAILURE,
    id,
    'recordDelete'
  );
